import { render, staticRenderFns } from "./AdvancedMailer.vue?vue&type=template&id=08532b34&scoped=true"
import script from "./AdvancedMailer.vue?vue&type=script&lang=js"
export * from "./AdvancedMailer.vue?vue&type=script&lang=js"
import style0 from "./AdvancedMailer.vue?vue&type=style&index=0&id=08532b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08532b34",
  null
  
)

export default component.exports